import React, { ComponentPropsWithoutRef } from 'react';
import { Image, ImageDescription} from './Image';
import { Typo3Image } from '../provider/Typo3Provider/types';
import { Maybe } from '../types';
import {HtmlContent} from "./layout/HtmlContent";

type TypoImageProps = {
  image: Maybe<Typo3Image>;
  hideDescription?: boolean | undefined;
} & ComponentPropsWithoutRef<'img'>;

// TODO: rename Component due to name collision with Type TypoImage
export const TypoImage = ({ image, ...props }: TypoImageProps) => {
  if (!image) {
    return null;
  }

  if (!props.hideDescription && image.description) {
    return(
      <div>
          <Image src={image.imageUri} {...props} />
          {image.description && <ImageDescription><HtmlContent htmlString={image.description} /></ImageDescription>}
        </div>
    )
  } else {
      return (<Image src={image.imageUri} {...props} />);
  }
};
